import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutter i millisekunder
let timeoutId;

const resetTimeout = () => {
  console.log('Timer nulstillet');
  if (timeoutId) clearTimeout(timeoutId);
  timeoutId = setTimeout(async () => {
    console.log('Timer udløbet - logger ud');
    await signOut(auth);
  }, TIMEOUT_DURATION);
};

export const setupSessionTimeout = () => {
  console.log('Session timeout setup startet');
  // Nulstil timer ved brugerinteraktion
  const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
  events.forEach(event => {
    document.addEventListener(event, resetTimeout);
  });
  
  resetTimeout();
};

export const clearSessionTimeout = () => {
  if (timeoutId) clearTimeout(timeoutId);
  const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
  events.forEach(event => {
    document.removeEventListener(event, resetTimeout);
  });
}; 